import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

export interface IAgRowAction<T = any> {
  // Material icon ligature, e.g. 'edit' or 'content_copy'.
  icon: string;
  // Tooltip and aria-label.
  label: string;
  onClick: (data: T) => void;
  hidden?: (data: T) => boolean;
}

export interface IAgRowActionsRendererParams<T = any> {
  actions: IAgRowAction<T>[];
}

// A row of icon buttons for an action column. Clicks don't bubble to the row, so row-click
// handlers (e.g. master/detail expand) aren't triggered by an action.
@Component({
    selector: 'app-ag-row-actions-renderer',
    templateUrl: './ag-row-actions-renderer.component.html',
    styleUrl: './ag-row-actions-renderer.component.scss',
    imports: [MatIconButton, MatIcon, MatTooltip]
})
export class AgRowActionsRendererComponent implements ICellRendererAngularComp {

  actions: IAgRowAction[] = [];
  data: any;

  agInit(params: ICellRendererParams & IAgRowActionsRendererParams): void {
    this.setValue(params);
  }

  refresh(params: ICellRendererParams & IAgRowActionsRendererParams): boolean {
    this.setValue(params);
    return true;
  }

  onActionClick(event: MouseEvent, action: IAgRowAction) {
    event.stopPropagation();
    action.onClick(this.data);
  }

  private setValue(params: ICellRendererParams & IAgRowActionsRendererParams) {
    this.data = params.data;
    this.actions = (params.actions ?? []).filter(a => !a.hidden?.(params.data));
  }
}
